










import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class BookingCalendarBadge extends Vue {

    public get baseClass(): string {
        return `${this.vertical ? 'vertical-badge' : ''} ${this.dark ? 'darken-2' : ''} ${this.color}`;
    }

    public get badgeColor(): string {
        return `${this.color} ${this.dark ? 'darken-4' : 'darken-2'}`;
    }

    public get darkSheet(): string {
        return this.dark ? 'darken-2' : '';
    }

    @Prop({default: false})
    public vertical!: boolean;
    @Prop({default: 0})
    private count!: number;

    @Prop({default: ''})
    private text!: string;

    @Prop({default: 'success'})
    private color!: string;

    @Prop({default: 'info'})
    private icon!: string;

    @Prop({default: false})
    private dark!: boolean;

    public responsiveSize(mod: number = 1): string {
        let size = 12 * mod;
        if (this.isLG(null)) {
            size = 14 * mod;
        }
        if (this.isXL(null)) {
            size = 16 * mod;
        }
        return `font-size:${size}px`;
    }
}
